export default function LivePulseDot({ label = 'Live', dark = false }) {
  return (
    <span className={`inline-flex items-center gap-2 text-xs ${dark ? 'text-white/80' : 'text-brand-text'}`}>
      <span className="relative inline-flex">
        <span className="w-2 h-2 rounded-full bg-brand-success animate-live-pulse" />
      </span>
      <span className="uppercase tracking-wider font-semibold">{label}</span>
    </span>
  )
}
